// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ig3hg","notes":"Notes_notes__3yFot","note":"Notes_note__t7Zx2","markdown":"Notes_markdown__3egFv"};